/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownProposedCourseStatus } from '../models/db_DropdownProposedCourseStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProposedCourseStatuses {
    /**
     * Get a list of proposed course statuses
     * @returns db_DropdownProposedCourseStatus OK
     * @throws ApiError
     */
    public static listProposedCourseStatuses(): CancelablePromise<Array<db_DropdownProposedCourseStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/proposed-course-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
